import { render, staticRenderFns } from "./DraggableUserSignature.vue?vue&type=template&id=6ae766de&"
import script from "./DraggableUserSignature.vue?vue&type=script&lang=js&"
export * from "./DraggableUserSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae766de')) {
      api.createRecord('6ae766de', component.options)
    } else {
      api.reload('6ae766de', component.options)
    }
    module.hot.accept("./DraggableUserSignature.vue?vue&type=template&id=6ae766de&", function () {
      api.rerender('6ae766de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/components/DraggableUserSignature.vue"
export default component.exports